<div class="layout" fxLayout="column" fxLayoutAlign="center center">
  <router-outlet></router-outlet>
  <!-- <footer>
    <a href="//www.trustcerts.de">Copyright by TrustCerts</a> |
    <a href="//www.trustcerts.de/impressum">Impressum</a>
  </footer> -->
</div>
